module.exports = __webpack_public_path__ + "img/iconmore.e441c84a.svg";